export var BASIC_BRANCHENBUCH_AGENT = 'BasicBranchenbuchAgent';
export var BRANCHENBUCH_AGENT = 'BranchenbuchAgent';
export var PRO_MARKETEER_AGENT = 'ProMarketeerAgent';